import { useRef } from 'react';
import type { Input } from '../platform/input';

export function TouchPad({ input, extra }: { input: Input; extra?: Array<{ id: string; label: string; on: () => void; off: () => void }> }) {
  const origin = useRef<{ x: number; y: number; id: number } | null>(null);

  return (
    <div className="touch-pad" aria-hidden>
      <div
        className="stick-well"
        onPointerDown={(e) => {
          (e.target as HTMLElement).setPointerCapture(e.pointerId);
          const r = (e.currentTarget as HTMLElement).getBoundingClientRect();
          origin.current = { x: r.left + r.width / 2, y: r.top + r.height / 2, id: e.pointerId };
          const dx = (e.clientX - origin.current.x) / 48;
          const dy = (e.clientY - origin.current.y) / 48;
          const m = Math.hypot(dx, dy) || 1;
          input.stick.x = Math.max(-1, Math.min(1, dx / Math.max(1, m)));
          input.stick.y = Math.max(-1, Math.min(1, dy / Math.max(1, m)));
        }}
        onPointerMove={(e) => {
          if (!origin.current || origin.current.id !== e.pointerId) return;
          const dx = (e.clientX - origin.current.x) / 48;
          const dy = (e.clientY - origin.current.y) / 48;
          const m = Math.max(1, Math.hypot(dx, dy));
          input.stick.x = dx / m;
          input.stick.y = dy / m;
        }}
        onPointerUp={() => {
          origin.current = null;
          input.stick.x = 0;
          input.stick.y = 0;
        }}
      >
        <span>move</span>
      </div>
      <div className="touch-actions">
        {(extra ?? []).map((b) => (
          <button
            key={b.id}
            type="button"
            className="touch-btn"
            onPointerDown={(e) => {
              e.preventDefault();
              b.on();
            }}
            onPointerUp={b.off}
            onPointerCancel={b.off}
          >
            {b.label}
          </button>
        ))}
      </div>
    </div>
  );
}
